export default "__VITE_ASSET__u$8E$TK___"